import type { Stripe, StripeConstructorOptions } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { computedAsync } from '@vueuse/core';
import isbot from 'isbot';
import type { App, Ref } from 'vue';
import type { Router } from 'vue-router';
import { useAuth } from './auth';

export const load = async (publishableKey: string, options?: StripeConstructorOptions) => {
  try {
    return (await loadStripe(publishableKey, options)) || undefined;
  } catch (error) {
    if (!isbot(navigator.userAgent)) {
      throw error;
    }

    return;
  }
};

export const useStripe = (publishableKey?: string): Ref<Stripe | undefined> =>
  computedAsync(() => load(publishableKey ?? import.meta.env.VITE_STRIPE_PK), undefined);

export const stripe = {
  install(app: App, { router }: { router: Router }): void {
    router.afterEach(async (to, from) => {
      if (from.name !== undefined && !window.Stripe && useAuth().isAuthenticatedAs('user')) {
        load(import.meta.env.VITE_STRIPE_PK);
      }
    });
  },
};
